import React from 'react';
import { Box, Breadcrumb, Link } from 'vindi-ds-components';
import { PrChevronLeft } from 'vindi-ds-icons/pr';
import Token from 'vindi-ds-tokens';
import styles from './styles';
import HeaderTitle from './title';
import HeaderNavigation from './navigation';
import HeaderActions from './actions';

function Header({ children, style }) {
  return (
    <Box css={style || styles.container} data-testid='header'>
      {children}
    </Box>
  );
}

function DefaultHeader({ links, title, children }) {
  return (
    <Header>
      <Header.Navigation>
        <Breadcrumb links={links}>
          {title}
        </Breadcrumb>
      </Header.Navigation>
      <Header.Title>{title}</Header.Title>
      <Header.Actions>
        {children}
      </Header.Actions>
    </Header>
  );
}

function HeaderWithoutAction({ links, title }) {
  return (
    <Header style={styles.noActions}>
      <Header.Navigation>
        <Breadcrumb links={links}>
          {title}
        </Breadcrumb>
      </Header.Navigation>
      <Header.Title>
        {title}
      </Header.Title>
    </Header>
  );
}

function HeaderMobile({ links, title }) {
  return (
    <Box pb={3} data-testid='header-mobile'>
      <Link
        href={links}
        style={styles.mobileRoot}
      >
        <PrChevronLeft
          size={Token.font.size.medium.value}
          color={Token.color.functional.dark[400].value}
        />
      </Link>

      <Header.Title>{title}</Header.Title>
    </Box>
  );
}

Header.Title = HeaderTitle;

Header.Navigation = HeaderNavigation;

Header.Actions = HeaderActions;

Header.Default = DefaultHeader;

Header.Mobile = HeaderMobile;

Header.WithoutAction = HeaderWithoutAction;

export default Header;
